import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import {
  FETCH_GROUP_SUCCESS,
  CREATE_GROUP_SUCCESS,
  UPDATE_GROUP_SUCCESS,
  FETCH_GROUP_SELECT_SUCCESS,
  FETCH_GROUPS_SELECT_SUCCESS,
  FETCH_GROUPS_BY_EXTENSION_SUCCESS,
} from '../actionTypes';

/** @typedef {import('utils/ReduxUtils').EntitySlice<import('../types').Group>} GroupDataEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<import("../types/group").Group>} */
const groupAdapter = createEntityAdapter({ selectId: ({ id }) => id });

/**
 * @param {GroupDataEntity} state
 * @param {import('modules/global/generic.types').PageContent<import('../types').Group>} action
 * @returns {GroupDataEntity}
 */
const updateManyFromPage = (state, { payload: { content } }) => groupAdapter.updateMany(state, content);

export default createReducer(groupAdapter.getInitialState(), {
  // Single group operations
  [FETCH_GROUP_SUCCESS]: groupAdapter.addOne,
  [CREATE_GROUP_SUCCESS]: groupAdapter.addOne,
  [UPDATE_GROUP_SUCCESS]: groupAdapter.addOne,
  [FETCH_GROUP_SELECT_SUCCESS]: groupAdapter.addOne,
  // Update blob
  [FETCH_GROUPS_SELECT_SUCCESS]: updateManyFromPage,
  [FETCH_GROUPS_BY_EXTENSION_SUCCESS]: updateManyFromPage,
});
